import moment from "moment";
import { AxiosClient, AxiosClientServerNuxt } from "../../utils/axios";
import { getIdFromSlug } from "~/utils/common";
import { logError } from "../../utils/logError";
import Axios from "axios";
export const state = () => ({
  listEvent: [],
  metadata: {
    current_page: 1,
    page_size: 10,
    total_items: -1,
    total_page: -1,
  },
  newestEventData: [],
  newestEducationData: [],
  schoolEvent: [],
  eventLoading: true,
  newestEventLoading: true,
  newestEducationLoading: true,
  eventDetail: {},
});

export const mutations = {
  SET_EVENT_DATA(state, { data: listEvent, metadata, newList }) {
    if (newList) {
      state.listEvent = listEvent ? listEvent : [];
    } else {
      state.listEvent.push(...listEvent);
    }
    state.metadata = metadata
      ? metadata
      : { current_page: 1, page_size: 10, total_items: -1, total_page: -1 };
  },
  SET_DETAIL_EVENT_DATA(state, payload) {
    state.eventDetail = payload;
  },
  SET_NEWEST_EVENT_DATA(state, payload) {
    state.newestEventData = payload;
  },
  SET_NEWEST_EDU_DATA(state, payload) {
    state.newestEducationData = payload;
  },
  SET_NEWEST_EVENT_LOADING(state, payload) {
    state.newestEventLoading = payload;
  },
  SET_NEWEST_EDU_LOADING(state, payload) {
    state.newestEducationLoading = payload;
  },
  SET_EVENT_LOADING(state, payload) {
    state.eventLoading = payload;
  },
  SET_SCHOOL_EVENT(state, payload) {
    state.schoolEvent = payload;
  },
};

export const actions = {
  async getListNewestEvent({ commit, rootState }, { location }) {
    commit("SET_NEWEST_EVENT_LOADING", true);
    const domain = this.$config.BASE_URL_CLIENT;
    try {
      // const res = await AxiosClient.get(
      //   `/api111/event/get-list-newest-event?location=${location}`,
      //   {}
      // );
      const res = await Axios.get(
        `${domain}/api/event/get-list-newest-event?location=${location}`,
        {},
      );
      const { data, code } = res.data;
      if (code == 200) {
        commit("SET_NEWEST_EVENT_DATA", data);
      } else {
        commit("SET_NEWEST_EVENT_DATA", []);
      }
    } catch (error) {
      logError(error, "getListNewestEvent on store");

      commit("SET_NEWEST_EVENT_DATA", []);
    }
    commit("SET_NEWEST_EVENT_LOADING", false);
  },
  async getListNewestEventEducation({ commit, rootState }, { location }) {
    commit("SET_NEWEST_EDU_LOADING", true);
    try {
      const domain = this.$config.BASE_URL_CLIENT;
      const res = await Axios.get(
        `${domain}/api/event/get-list-newest-event-education`,
        {},
      );
      // API returns { Success, Message, Data: [...] }
      const raw = res.data?.Data || [];
      // map to same structure expected by EventNews/Event
      const mapped = raw.map((item) => {
        return {
          id: item.NewsId,
          thumb: item.Avatar ? `https://cdn.tuoitre.vn/${item.Avatar}` : "",
          avatar: item.Avatar ? `https://cdn.tuoitre.vn/${item.Avatar}` : "",
          title: item.Title,
          location: item.ZoneName || "",
          num_of_register: 0,
          releaseDate: {
            date: moment(item.DistributionDate).format("D"),
            month: moment(item.DistributionDate).format("M"),
          },
        };
      });
      commit("SET_NEWEST_EDU_DATA", mapped);
    } catch (error) {
      logError(error, "getListNewestEventEducation on store");
      commit("SET_NEWEST_EDU_DATA", []);
    }
    commit("SET_NEWEST_EDU_LOADING", false);
  },
  async getListEvent(
    { commit, rootState },
    { filter_by, page_size, page, sort_by, order, newList },
  ) {
    commit("SET_EVENT_LOADING", true);
    try {
      const domain = this.$config.BASE_URL_CLIENT;

      // const res = await AxiosClient.get(
      //   encodeURI(
      //     `/api/event/get-list-event?filter_by=${filter_by}&page_size=${page_size}&page=${page}&sort_by=${sort_by}&order=${order}`
      //   ),
      //   {}
      // );
      const res = await Axios.get(
        `${domain}/api/event/get-list-event?filter_by=${filter_by}&page_size=${page_size}&page=${page}&sort_by=${sort_by}&order=${order}`,
        {},
      );
      const { data, code } = res.data;
      if (code == 200) {
        commit("SET_EVENT_DATA", { ...data, newList });
      } else {
        commit("SET_EVENT_DATA");
      }
    } catch (error) {
      logError(error, "getListEvent on store");
    }
    commit("SET_EVENT_LOADING", false);
  },

  async getListEventOfSchool({ commit, rootState }, { schoolId }) {
    commit("SET_EVENT_LOADING", true);

    try {
      const domain = this.$config.BASE_URL_CLIENT;
      const res = await AxiosClient.get(
        encodeURI(
          `/api/event/get-list-event-of-school?school_id=${schoolId}&page_size=3&page=1`,
        ),
        {},
      );
      // const res = await Axios.get(
      //   `${domain}/api/event/get-list-event-of-school?school_id=${schoolId}&page_size=3&page=1`,
      //   {}
      // );
      const { data, code } = res.data;
      if (code == 200) {
        commit("SET_SCHOOL_EVENT", data.data);
      } else {
        commit("SET_SCHOOL_EVENT", []);
      }
    } catch (error) {
      commit("SET_SCHOOL_EVENT", []);
      logError(error, "getListEventOfSchool on store");
    }
    commit("SET_EVENT_LOADING", false);
  },

  async getEventDetail({ commit, rootState }, payload) {
    commit("SET_EVENT_LOADING", true);
    try {
      const isOnServer = process.server;
      const domain = this.$config.BASE_URL_CLIENT;

      let res;
      if (isOnServer && getIdFromSlug(payload)) {
        let url = encodeURI(
          `/eduzone/api/event/get-detail-event/${getIdFromSlug(payload)}`,
        );

        res = await AxiosClientServerNuxt.get(url, {});
      } else {
        let url = encodeURI(
          `/eduzone/api/event/get-detail-event/${getIdFromSlug(payload)}`,
        );

        // res = await AxiosClient.get(url);
        res = await Axios.get(url);
      }

      if (res.status === 200) {
        commit("SET_DETAIL_EVENT_DATA", res.data.data);
        commit("SET_EVENT_LOADING", false);
        return res.data.data;
      }
    } catch (error) {
      logError(error, "getEventDetail on store");
    }
    commit("SET_EVENT_LOADING", false);
  },
};
